import React, { useState } from "react";

import { serverUrl, apiEndpoints } from "../../config";

import PostSingle from "../../partials/posts/postSingle";

import MicNoneIcon from "@mui/icons-material/MicNone";
import { Typography } from "@mui/material";

export default function PodcastSingle(props) {
  const [post, setPost] = useState(null);

  const renderPostAudio = (_post) => {
    if (!_post) return null;

    let audioSrc = _post.field_audio;
    const fileToken = _post.file_access_token;

    if (fileToken) {
      audioSrc = `${serverUrl}/shared/files/${_post.filename}?access_token=${fileToken}`;
    }

    return (
      <div className="post-podcast-container">
        <audio controls className="post-podcast w-100 mt-4 mb-3">
          <source src={audioSrc} alt={`Audio for ${_post.title}`} />
        </audio>
        <div className="artist-container d-flex align-items-center justify-content-center mb-4">
          <div className="artist">
            <Typography
              className="d-flex"
              owner="client"
              variant="body1"
              color="clientPrimary.main"
            >
              <MicNoneIcon className="me-1" sx={{ fontSize: 20 }} />
              {_post.field_artist}
            </Typography>
          </div>
        </div>
      </div>
    );
  };

  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.podcasts}
      featuredImageEnabled={true}
      entityFavoritesContentType={"podcast"}
      previewReturnRoute={"/podcasts-creator"}
      returnRoute={"/podcasts"}
      backBtnText={"Podcast Library"}
      screenClassName={"podcasts"}
      v2Bundle={"podcast"}
      logCustomEventType={"Podcast"}
      entityType={"podcast"}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
      {renderPostAudio(post)}
    </PostSingle>
  );
}
